import getAccountBySourceId from '../selectors/getAccountBySourceId';
import { accountRankTypeChecker } from '../store/schema/AccountSourceList';
import setCoprincipalAdditionalProps from './setCoprincipalAdditionalProps';

export default function removeEasidAsLicensingMailboxInfo(sourceId: string): void {
    const accountSource = getAccountBySourceId(sourceId);
    if (accountRankTypeChecker.isCoprincipal(accountSource)) {
        setCoprincipalAdditionalProps(sourceId, {
            licensingMailboxInfo: undefined,
        });
    }
}
